import CreatePasswordContainer from "./CreatePasswordContainer";

export default CreatePasswordContainer;
